<div class="card-header">
  <div class="card-title">
    <ng-content></ng-content>
  </div>
</div>
